import React from "react";

const MAP = {
  "En attente de Fanny": {
    bg: "bg-[#FEF3C7]", text: "text-[#92400E]", border: "border-[#FDE68A]", dot: "bg-[#D97706]",
  },
  "À toi de jouer": {
    bg: "bg-[#FDF2F4]", text: "text-bordeaux", border: "border-bordeaux-border", dot: "bg-bordeaux",
  },
  "Corrections disponibles": {
    bg: "bg-[#ECFDF5]", text: "text-[#065F46]", border: "border-[#A7F3D0]", dot: "bg-[#059669]",
  },
  "En attente de correction": {
    bg: "bg-[#FEF3C7]", text: "text-[#92400E]", border: "border-[#FDE68A]", dot: "bg-[#D97706]",
  },
};

const LABELS = {
  "À toi de jouer": "Tâche à faire",
  "En attente de Fanny": "En attente de validation par Fanny",
};

export function StatusBadge({ status, className = "" }) {
  const s = MAP[status] || MAP["À toi de jouer"];
  return (
    <span
      data-testid={`status-badge-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium ${s.bg} ${s.text} ${s.border} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {LABELS[status] || status}
    </span>
  );
}
